import React from 'react';
import axios from 'axios';

class Admin extends React.Component {
  constructor() {
    super();
    this.state = {
      value: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { value } = this.state;
    if (value) {
      const data = { value };
      try {
        const response = await axios({
          method: 'post',
          url: 'pram/api/v1/query',
          data,
          headers: { 'content-type': 'application/json' },
          json: true,
        });
        if (response.status === 200) {
          console.warn('Record sent');
        }
      } catch (error) {
        console.log({ error });
      }
    }
    // Clear Form
    this.setState({ value: '' });
  }

  render() {
    const { value } = this.state;
    return (
      <form onSubmit={this.handleSubmit} style={{ marginLeft: '25rem', marginTop: '4rem' }}>
        <div>
          <b>Admin Module:</b>
        </div>
        <div>
          <textarea
            style={{
              margin: '0px', height: '121px', width: '414px', resize: 'both',
            }}
            value={value}
            onChange={this.handleChange}
          />
        </div>
        <div>
          <input style={{ fontSize: 'small' }} type="submit" value="Execute Query" />
        </div>
      </form>
    );
  }
}

export default Admin;

/** Old Admin page has removed because not form.Control is not working on internet explorer */
// class Admin extends React.Component {

//   constructor() {
//     super();
//     this.state = {
//       query: null,
//     };

//     this.handleInputChange = this.handleInputChange.bind(this);
//     this.submit = this.submit.bind(this);
//   }

//   handleInputChange(event) {
//     event.preventDefault();
//     this.setState({
//       query: event.target.value,
//     });
//   }

//   async submit(e) {
//     e.preventDefault();
//     console.warn(this.state.query);
//     const { query } = this.state;
//     const data = {
//       query,
//     };
//     if (this.state.query) {
//       await axios({
//         method: 'post',
//         url: 'pram/api/v1/query',
//         data,
//         headers: { 'content-type': 'application/json' },
//         json: true,
//       }).then((response) => {
//         if (response.status === 200) {
//           console.warn('Recoed sent--------');
//         }
//       }).catch((error) => {
//         console.log({ error });
//       });
//     }

//     // Clear Form
//     this.setState({
//       query: '',
//     });
//   }

//   render() {
//     return (
//       <div>
//         <Form onSubmit={this.submit}>
//           <Form.Group style={{ width: '40rem' }} controlId="exampleForm.ControlTextarea1">
//             <Form.Label>Admin Module</Form.Label>
//             <input type="textarea" rows="3" name="address" onChange={this.handleInputChange} />
//           </Form.Group>
//           <Form.Group >
//             <button type="submit" className="submit-btn">Execute Query</button>
//           </Form.Group>
//         </Form>
//       </div>
//     );
//   }
// }

// export default Admin;
